/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	"use strict";
	/*globals Tc, doT, SCS */
	/*jshint smarttabs:true */

	var makePrice = require('lib/ecommerce/Price').default;

	/**
	 * ProductOptionsSummary module implementation.
	 *
	 * @author Stefan Maurer
	 * @namespace Tc.Module
	 * @class ProductOptionsSummary
	 * @extends Tc.Module
	 */
	Tc.Module.ProductOptionsSummary = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.updateSubtotal();
			mod.updateAddress();

			// ensure this event is only bound once
			$(":input[data-price],:input[data-onetime-charge],:input[data-type=item],sdx-input-item[data-price],sdx-input-item[data-onetime-charge],sdx-input-item[data-type=item]").off("change.ProductOptionsSummary");
			$(":input[data-price],:input[data-onetime-charge],:input[data-type=item],sdx-input-item[data-price],sdx-input-item[data-onetime-charge],sdx-input-item[data-type=item]").on("change.ProductOptionsSummary", $.proxy(mod.updateSubtotal, mod));

			callback();
		},

		onBeforeShowStep: function (data) {
			var mod = this;

			if (mod.$ctx.parents('#' + data.stepId).length > 0) {
				debug.log("Tc.Module.ProductOptionsSummary.js > BeforeShowStep " + data.stepId);
				mod.updateAddress();
			}
		},

		onPriceAdded: function (data) {
			var mod = this;

			mod.updateSubtotal();
			// ensure this event is only bound once
			$(":input[data-price],:input[data-onetime-charge],:input[data-type=item],sdx-input-item[data-price],sdx-input-item[data-onetime-charge],sdx-input-item[data-type=item]").off("change.ProductOptionsSummary", $.proxy(mod.updateSubtotal, mod));
			$(":input[data-price],:input[data-onetime-charge],:input[data-type=item],sdx-input-item[data-price],sdx-input-item[data-onetime-charge],sdx-input-item[data-type=item]").on("change.ProductOptionsSummary", $.proxy(mod.updateSubtotal, mod));

		},

		updateAddress: function () {
			var mod = this,
				deliveryAddress = $('.deliveryAddress', mod.$ctx),
				deliverySame = $(":input[name='" + deliveryAddress.attr('data-fieldDeliveryAddressSwitch') + "']").is(':checked'),
				deliverySuffix = (deliverySame) ? "" : "Delivery",
				company = $(":input[name='" + deliveryAddress.attr('data-fieldCompany' + deliverySuffix) + "']").val(),
				salutation = $(":input[name='" + deliveryAddress.attr('data-fieldSalutation' + deliverySuffix) + "']:checked").val(),
				prename = $(":input[name='" + deliveryAddress.attr('data-fieldPrename' + deliverySuffix) + "']").val(),
				surname = $(":input[name='" + deliveryAddress.attr('data-fieldSurname' + deliverySuffix) + "']").val(),
				street = $(":input[name='" + deliveryAddress.attr('data-fieldStreet' + deliverySuffix) + "']").val(),
				zip = $(":input[name='" + deliveryAddress.attr('data-fieldZip' + deliverySuffix) + "']").val(),
				city = $(":input[name='" + deliveryAddress.attr('data-fieldCity' + deliverySuffix) + "']").val(),
				html = '';

			if (company) {
				html += company + '<br />';
			}
			if (salutation) {
				html += salutation + '<br />';
			}
			if (prename || surname) {
				html += prename + ' ' + surname + '<br />';
			}
			if (street) {
				html += street + '<br />';
			}
			if (zip || city) {
				html += zip + ' ' + city;
			}

			deliveryAddress.html(html);
		},

		isHidden: function($element) {
			// checking if parent of element is hidden
			var $visibilityContainer = $element.closest(".modVisibilityControlContainer");

			if($visibilityContainer.children(':input[type=select]').length) {
				return $visibilityContainer.is(":hidden");
			}
			else {
				return true;
			}
			return false;
		},

		updateSubtotal: function () {
			var mod = this,
				prices = {
					items: [],
					monthlyPrices: [],
					onetimePrices: [],
					subTotalOnetime: 0,
					subTotalMonthly: 0
				},
				$form = $(".modScForm form"); // not a parent or child of this mod


			debug.log("Tc.Module.ProductOptionsSummary.js > updateSubtotal");

			// remove current content
			mod.$ctx.find(".priceOverview").remove();
			mod.$ctx.find("#totalOneTimeCost").remove();
			mod.$ctx.find("#totalMonthlyCost").remove();

			// add items price info
			$form.find(':input[data-price],.modBaseBundleOption :input[data-hascost],sdx-input-item[data-price],.modBaseBundleOption sdx-input-item[data-hascost]').each(function () {
				var	$this = $(this),
					itemCountRaw = ($this.filter('[data-hascost]').length && $this.data('hascost') != '') ? $this.data('hascost') : $this.val(),
					itemCount = itemCountRaw == '' ? 0 : itemCountRaw,
					itemPrice = '',
					itemPriceFormatted = '',
					isCheckboxOrRadio = ['checkbox', 'radio'].indexOf(this.type) > -1,
					summary = $this.data('summary') || "",
					itemLabel = $this.data('label'),
					prio = $this.data('prio') || 0;

				if($this.data('price') === '0.00') {
					itemPrice = 1;
					itemPriceFormatted = '0.00';
				}
				else {
					itemPrice = itemCount * $this.data('price');
					itemPriceFormatted = makePrice(itemPrice).formatted();
				}

				var isCheckedRadioOrCheckbox = isCheckboxOrRadio && $this.prop('checked');
				if($this.is('sdx-input-item:not(.hydrated)')) {
					isCheckedRadioOrCheckbox = $this.attr('checked');
				}

				if (itemCount && (!isCheckboxOrRadio || isCheckedRadioOrCheckbox) && itemPrice && mod.isHidden($this)) {
					prices.items[itemLabel] = {
						label: itemLabel,
						itemCount: (itemCount > 0 ? itemCount : ''),
						description: summary,
						onetimePrice: '',
						monthlyPrice: itemPriceFormatted
					};
					prices.monthlyPrices[itemLabel] = {
						description: summary,
						label: itemLabel,
						itemCount: (itemCount > 0 ? itemCount : ''),
						price: itemPriceFormatted,
						prio: prio
					};
					// Making sure we are not adding +1 to the total price
					if ($this.data('price') !== '0.00') {
						prices.subTotalMonthly += itemPrice;
					}
				}

			});

			$('.one-time-summary', mod.$ctx).addClass('ui-helper-hidden');
			prices.subTotalMonthly = parseFloat(Math.round(prices.subTotalMonthly * 100) / 100).toFixed(2);

			// add items price info
			$form.find(":input[data-onetime-charge],.modBaseBundleOption :input[data-hascost],sdx-input-item[data-onetime-charge],.modBaseBundleOption sdx-input-item[data-hascost]").each(function () {
				var $this = $(this),
					itemCountRaw = ($this.filter('[data-hascost]').length && $this.data('hascost') != '') ? $this.data('hascost') : $this.val(),
					itemCount = itemCountRaw == '' ? 0 : itemCountRaw,
					isCheckboxOrRadio = ['checkbox', 'radio'].indexOf(this.type) > -1,
					summary = $this.data('summary') || '',
					itemLabel = $this.data('label'),
					itemPrice = '',
					itemPriceFormatted;
				if($this.data('onetime-charge') === '0.00') {
					itemPrice = 1;
					itemPriceFormatted = '0.00';
				}
				else {
					itemPrice = itemCount * $this.data('onetime-charge');
					itemPriceFormatted = makePrice(itemPrice).formatted();
				}

				var isCheckedRadioOrCheckbox = isCheckboxOrRadio && $this.prop('checked');
				if($this.is('sdx-input-item:not(.hydrated)')) {
					isCheckedRadioOrCheckbox = $this.attr('checked');
				}

				if (itemCount && (!isCheckboxOrRadio || isCheckedRadioOrCheckbox) && itemPrice) {
					if (prices.items[itemLabel]) {
						prices.items[itemLabel].onetimePrice = itemPriceFormatted;
					} else {
						prices.items[itemLabel] = {
							label: itemLabel,
							itemCount: (itemCount > 0 ? itemCount : ''),
							description: summary,
							onetimePrice: itemPriceFormatted,
							monthlyPrice: ''
						};
					}
					prices.onetimePrices[itemLabel] = {
						label: itemLabel,
						description: summary,
						itemCount: (itemCount > 0 ? itemCount : ''),
						price: itemPriceFormatted
					};
					// Making sure we are not adding +1 to the total price
					if ($this.data('onetime-charge') !== '0.00') {
						prices.subTotalOnetime += itemPrice;
					}
				}

			});

			if (prices.subTotalOnetime > 0) {
				$('.one-time-summary', mod.$ctx).removeClass('ui-helper-hidden');
			}

			prices.subTotalOnetime = parseFloat(Math.round(prices.subTotalOnetime * 100) / 100).toFixed(2);

			// Add class summary-page for multipage-summary-step
			mod.$ctx.addClass("summary-page");

			// remove keys from prices.items (dot template wants numeric array keys)
			function assocToArray(obj) {
				return Object.keys(obj).map(function(key) {
					return obj[key];
				});
			}

			prices.items = assocToArray(prices.items);
			prices.monthlyPrices = assocToArray(prices.monthlyPrices);
			prices.onetimePrices = assocToArray(prices.onetimePrices);
			prices.monthlyPrices.sort(function(a, b) {
				return b.prio - a.prio;
			});
			prices.onetimePrices.reverse();

			var templateScript = mod.$ctx.find('script.tmpl-productOptionsSummary'),
				template = doT.template(templateScript.html());

			templateScript.after(template(prices));
		}
	});
})(Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductOptionsSummary.js
// module id = 253
// module chunks = 0